import { Colors, Icon, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

/** The line under an opening statement that hands it over to the manager: a base was offered, it is
 * theirs to rework. */
export const AgendaOpeningStatementHint = () => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'mt-3 flex items-center gap-1.5 pl-6'}>
            <Icon
                name={'lucide-sparkles'}
                size={20}
                color={Colors.SECONDARY}
            />

            <Text
                size={'small'}
                className={
                    'from-secondary-600 to-primary-500 bg-gradient-to-r bg-clip-text text-[12px] text-transparent italic'
                }
            >
                {t('meetingAgenda.openingStatementAiHint')}
            </Text>
        </div>
    );
};
